<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    class="bg-gray-100 py-4 px-6 mb-8"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      Invite user
    </h3>

    <FormulateInput
      v-if="!edit"
      name="email"
      type="email"
      label="Email address"
      placeholder="Email address"
      validation="bail|required|email"
    />
    <FormulateInput
      name="role"
      :options="{
        regular: 'regular',
        'company-admin': 'admin',
        'company-owner': 'owner',
      }"
      type="select"
      label="Role"
      placeholder="Select a role"
    />

    <FormulateErrors />

    <base-button type="submit" :loading="sending">
      {{ edit ? 'Save' : 'Invite' }}
    </base-button>
  </FormulateForm>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    companyRole: Object,
  },
  data() {
    return {
      formName: `userForm${this.companyRole ? this.companyRole.id : ''}`,
      formValues: this.companyRole || {},
      sending: false,
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
    }),
    edit() {
      return Boolean(this.companyRole);
    },
  },
  methods: {
    submit(data) {
      this.$formulate.resetValidation(this.formName);
      if (this.edit) {
        this.saveUser(data);
      } else {
        this.sendInvitation(data);
      }
    },
    async saveUser(formData) {
      try {
        this.sending = true;
        const { data } = await this.$api.patch(
          `companies/${this.currentCompanyId}/user_company_roles/${this.companyRole.id}/`,
          formData
        );
        this.$emit('edit', data);
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
    async sendInvitation(data) {
      try {
        this.sending = true;
        await this.$api.post(
          `companies/${this.currentCompanyId}/invitations/`,
          data
        );
        this.$emit('add-new');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
